import React from "react"

import { ToggleClass } from '../components/dom'

class MainContent extends React.Component {
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
    const comingSoon = document.querySelector("h1.fade");
    setTimeout(
      function() { ToggleClass(comingSoon, "load"); },
      500);
  }
  
  render () {
    return (
      <h1 class="fade">
        COMING SOON...
      </h1>
    )
  }
}

export default MainContent
